import { defineStore } from 'pinia';

type RabbitStatusPayload = {
  publish: number;
  publishRate: number;
  deliver: number;
  deliverRate: number;
  ack: number;
  ackRate: number;
  ts: number;
};

type ServiceStatusPayload = {
  build: string;
  env: string;
  id: number;
  pid: number;
  svc: string;
  ts: number;
  startedTs: number;
  mem: {
    rss: number;
    heapTotal: number;
    heapUsed: number;
    external: number;
    arrayBuffers: number;
  };
};

type ServiceStatuses = {
  name: string;
  nodes: ServiceStatusPayload[];
}

type StatusStoreState = {
  serviceStatus: { [name: string]: ServiceStatusPayload[] };
  statuses: ServiceStatuses[];
  rabbitStatus: RabbitStatusPayload | null;
};


export const useStatusStore = defineStore('status', {
  state: () =>
    ({
      serviceStatus: {},
      statuses: [],
      rabbitStatus: null,
    }) as StatusStoreState,
  actions: {
    handleRabbitMessage(message: RabbitStatusPayload) {
      this.rabbitStatus = message;
    },
    handleSocketMessage(message: ServiceStatusPayload) {
      const svcName = message.svc;
      if (!this.serviceStatus[svcName]) {
        this.serviceStatus[svcName] = [];
      }

      this.serviceStatus[svcName][message.id] = message;

      const pool = this.statuses.find((svc) => svc.name === svcName);

      if (!pool) {
        const newService = {
          name: svcName,
          nodes: [] as ServiceStatusPayload[],
        }
        newService.nodes[message.id] = message;

        this.statuses.push(newService);
      } else {
        pool.nodes[message.id] = message;
      }
    },
  },
});
